export default "__VITE_ASSET__5929e0cc__"